console.log("bundle quantities init");
const bundleQuantityInput = document.querySelectorAll("m-quantity-input-b");

document.addEventListener('click', function(e) {
  if (e.target.matches('.m-cart-quantity--button[name="minusBundle"]')) {
    e.preventDefault();
    var button = e.target;
    var qty = button.closest("m-quantity-input-b").querySelector(".m-cart-quantity--input").value;
    qty = parseInt(qty) - 1;
    if(qty != 0)
    {
      button.closest("m-quantity-input-b").querySelector(".m-cart-quantity--input").value = qty;
      var option = button.closest(".bundle-qty-wrapper").querySelector(".selected-item-option").value;
      var input = button.closest(".bundle-qty-wrapper").querySelectorAll("m-quantity-input-b");
      input.forEach(function(inpt) {
        option += " / " + inpt.querySelector(".m-cart-quantity--input").value;
      });
      console.log(option);
      var addProductId = button.closest(".bundle-qty-wrapper").querySelector("[data-title='"+option+"']").value;
      var removeProductId = button.getAttribute("data-key");
      DisableQuantityBtn();
      UpdateBundleProduct(button,removeProductId,addProductId);
    }
  }
  if (e.target.matches('.m-cart-quantity--button[name="plusBundle"]')) {
    e.preventDefault();
    var button = e.target;
    var qty = button.closest("m-quantity-input-b").querySelector(".m-cart-quantity--input").value;
    var max = button.closest("m-quantity-input-b").querySelector(".m-cart-quantity--input").getAttribute("data-max");
    qty = parseInt(qty) + 1;
    if(qty != 0)
    {
      if(qty < max)
      {
        button.closest("m-quantity-input-b").querySelector(".m-cart-quantity--input").value = qty;
      }
      else
      {
        button.closest("m-quantity-input-b").querySelector(".m-cart-quantity--input").value = max;
      }

      var option = button.closest(".bundle-qty-wrapper").querySelector(".selected-item-option").value;
      var input = button.closest(".bundle-qty-wrapper").querySelectorAll("m-quantity-input-b");
      input.forEach(function(inpt) {
        option += " / " + inpt.querySelector(".m-cart-quantity--input").value;
      });
      console.log(option);
      var addProductId = button.closest(".bundle-qty-wrapper").querySelector("[data-title='"+option+"']").value;
      var removeProductId = button.getAttribute("data-key");
      DisableQuantityBtn();
      UpdateBundleProduct(button,removeProductId,addProductId);
    }
  }
});

function UpdateBundleProduct(target,removeProductId,addProductId) {
  let updateItems = {};
  updateItems[removeProductId] = 0;
  
  let additem = {
    "id":addProductId,
    "quantity":1
  }
  
  if(updateItems != '')
  {
    if(!document.querySelector("body").classList.contains("template-cart"))
    {
      document.querySelector('.m-cart-drawer--inner').classList.add('al-loading-bar','loading', 'al-loading-overlay', 'overlay-show');
    }
    
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      body: JSON.stringify({ 
        'updates':updateItems,
        "sections": document.querySelector('m-cart-drawer')?.getSectionsToRender().map((section) => section.id),
        "sections_url": window.location.pathname,
      }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
      }
    }).then(response => {
      return response.json();
    }).then(response => {
       AddBundleProduct(additem);
    }).catch((error) => {
      document.querySelector('.m-cart-drawer--inner').classList.remove('al-loading-bar','loading', 'al-loading-overlay', 'overlay-show');
      addtocart.closest(".product-form").classList.remove("adding");
      console.error('Error:', error);
    });
  }
}

function AddBundleProduct(item){
  let items = [item];  
  fetch(window.Shopify.routes.root + 'cart/add.js', {
      body: JSON.stringify({ 
        'items':items,
        "sections": document.querySelector('m-cart-drawer')?.getSectionsToRender().map((section) => section.id),
        "sections_url": window.location.pathname,
      }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
      }
    }).then(response => {
      return response.json();
    }).then(response => {
      if(!document.querySelector("body").classList.contains("template-cart"))
      {
         document.querySelector('m-cart-drawer').renderContents(response);
          document.querySelectorAll('.m-cart-drawer--inner').forEach(function(element) {
            element.classList.remove('al-loading-bar', 'loading', 'al-loading-overlay', 'overlay-show');
          });
          attachEventListeners();
          // addtocart.closest(".product-form").classList.remove("adding");
      }
      else
      {
        location.reload();
      }
    }).catch((error) => {
      document.querySelector('.m-cart-drawer--inner').classList.remove('al-loading-bar','loading', 'al-loading-overlay', 'overlay-show');
      addtocart.closest(".product-form").classList.remove("adding");
      console.error('Error:', error);
    });
}

function DisableQuantityBtn(){
  bundleQuantityInput.forEach(function(quantityInput){
    const btn = quantityInput.querySelectorAll("button");
    btn.forEach(function(disableBtn){
      disableBtn.setAttribute("disabled","disabled");
    });
  });
}